import {
  CareServiceOrgansKey,
  KeyImage,
  RadiologistStudyKeyImagesResponse,
  TextToStructuredObservation,
} from '@/api';

import { FindingsByOrgan, MappedKeyImage } from '../model';
import { isNotEmpty } from './is-empty.util';

export function getKeyImagesFromFindings(findings: FindingsByOrgan) {
  const findingsFlat: TextToStructuredObservation[] = Object.keys(findings).flatMap(
    (key) => findings[key as CareServiceOrgansKey],
  );

  const keyImagesInsideFindings: KeyImage[] = findingsFlat
    .filter((finding) => isNotEmpty(finding.renderedSummary.keyImages ?? []))
    .flatMap((finding) => finding.renderedSummary.keyImages ?? [])
    .filter((keyImage) => keyImage.status !== 'deprecated');

  return keyImagesInsideFindings;
}

export function getNonDeprecatedKeyImageLabels(labels: KeyImage[]) {
  return labels.filter((label) => label.status !== 'deprecated');
}

export function getMappedKeyImages(data: RadiologistStudyKeyImagesResponse): MappedKeyImage[] {
  const sortedInstanceNumbers = [...data.key_images.instanceNumbers].sort(
    (a, b) => Number(a) - Number(b),
  );

  return sortedInstanceNumbers.map((instanceNumber) => ({
    image: data.images[instanceNumber],
    imageKey: data.key_images.imageKeys[instanceNumber],
    instanceNumber,
    processedS3Key: data.key_images.processed?.[instanceNumber],
  }));
}
